import { createFileRoute } from '@tanstack/react-router';
import { TechnicianOffboardingView } from '@/components/organisms/technicians/TechnicianOffboardingView';

// GAP-02 (Delta 1) — offboarding is a dedicated full-screen page (not a drawer),
// nested under the technician like $id/edit so it renders through the Team
// Outlet. Uses the `$id` param to stay consistent with the sibling routes.
export const Route = createFileRoute('/_dashboard/dashboard/technicians/$id/offboarding')({
  // Which action the offboarding was entered for, so the footer gate runs the
  // ORIGINAL intent once 0 visits remain. Defaults to deactivate (direct entry).
  validateSearch: (search: Record<string, unknown>): { action: 'delete' | 'deactivate' } => ({
    action: search.action === 'delete' ? 'delete' : 'deactivate',
  }),
  component: TechnicianOffboardingPage,
});

function TechnicianOffboardingPage() {
  const { id } = Route.useParams();
  const { action } = Route.useSearch();
  return <TechnicianOffboardingView technicianId={id} action={action} />;
}
